import React from "react"
import { useParams } from "react-router"
import { WorklistRequest } from "../../../services/verifyService/commands";
import { useWorklistQuery } from "../../../services/verifyService/verify-api";
import { BenefitsWorklist } from "../features";
import { Loading } from "../../shared/features/Loading";
import { PayerSummaryWorklist } from "../features/worklists/PayerSummaryWorklist";
import { EscalatedWorklist } from "../features/worklists/EscalatedWorklist";
import { ServiceDateWorklist } from "../features/worklists/ServiceDateWorklist";
import { VobRequestWorklist } from "../features/worklists/VobRequestWorklist";
import { PreQuoteWorklist } from "../features/worklists/PreQuoteWorklist";
import { PreQuoteCreateDialog } from "../features/dashboard/PreQuoteCreateDialog";

function Worklist(){
    const {type,center,filter} = useParams();
    const {isLoading} = useWorklistQuery(new WorklistRequest(type!,center!,filter!));
    const showPayerSummary = center === "ALL" && filter === 'NA' && type !== 'Escalated' && type !== 'VobRequest' && type !== 'PreQuote' && !type?.startsWith('ServiceDate');
    const showEscalatedWorklist = type === 'Escalated';
    const showServiceDateWorklist = type?.startsWith('ServiceDate');
    const showVobRequestWorklist = type === 'VobRequest';
    const showPreQuoteWorklist = type === 'PreQuote';

    return <React.Fragment>
        {showPayerSummary ? <PayerSummaryWorklist/> :
            (isLoading ? <Loading/> :
                <div>
                    {showEscalatedWorklist && <EscalatedWorklist/>}
                    {showServiceDateWorklist && <ServiceDateWorklist/>}
                    {showVobRequestWorklist && <VobRequestWorklist/>}
                    {showPreQuoteWorklist && <PreQuoteWorklist/>}
                    {!showEscalatedWorklist && !showServiceDateWorklist && !showVobRequestWorklist && !showPreQuoteWorklist && center !== "ALL" &&
                        <BenefitsWorklist/>}
                    {!showEscalatedWorklist && !showServiceDateWorklist && !showVobRequestWorklist && !showPreQuoteWorklist && center === "ALL" && filter !== 'NA' &&
                        <BenefitsWorklist/>}
                </div>
            )
        }
        {showPreQuoteWorklist && <PreQuoteCreateDialog/>}
    </React.Fragment>
}

export{Worklist}